// Completion form rules and payload (KOP-40 spec §5.2). Pure.
import { hasUndone } from '@/components/field/fieldTasksLogic';

export const COMMENT_MAX = 1000;
const INT_RE = /^\d+$/;

function str(v) {
  return v === null || v === undefined ? '' : String(v);
}

export function emptyCompletionForm(paperBalance) {
  return {
    paper_balance: paperBalance === null || paperBalance === undefined ? '' : String(paperBalance),
    completion_comment: '',
  };
}

/** Ordered Russian messages; empty when the form is valid. `works` are `{ done }` rows. */
export function validateCompletionForm(form, works) {
  const errors = [];
  const paper = str(form.paper_balance).trim();
  if (paper === '') errors.push('Укажите остаток бумаги на объекте');
  else if (!INT_RE.test(paper)) errors.push('Остаток бумаги — целое число не меньше 0');
  const comment = str(form.completion_comment).trim();
  if (hasUndone(works) && comment === '') errors.push('Укажите комментарий: не все работы выполнены');
  if (comment.length > COMMENT_MAX) errors.push(`Комментарий не длиннее ${COMMENT_MAX} символов`);
  return errors;
}

export function completionPayload(taskId, form) {
  return {
    id: taskId,
    status_code: 'done',
    paper_balance: Number(str(form.paper_balance).trim()),
    completion_comment: str(form.completion_comment).trim(),
  };
}
